import { CustomNuanceTab, NuanceTab, customNuanceTabNames } from '@abstractTypes/nuance'
import { StandardProduct } from '@abstractTypes/product'
import { arrayIncludes } from './caseInsensitive'

export const isNuanceProduct = (product: StandardProduct) =>
  product.isNuanceFrame || product.isNuanceAccessories

export const isNuanceCustomTab = (tab: NuanceTab): tab is CustomNuanceTab =>
  !!tab.name && arrayIncludes(customNuanceTabNames, tab.name)
